/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionPrecomputeAccountStatus {
    getFixupPrototypeFunction() { return DimensionPrecomputeAccountStatus.fixupPrototype; }

    static newInstance(model: Partial<DimensionPrecomputeAccountStatus>): DimensionPrecomputeAccountStatus {
        let obj = Object.assign(new DimensionPrecomputeAccountStatus(), model);
        DimensionPrecomputeAccountStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionPrecomputeAccountStatus>): DimensionPrecomputeAccountStatus {
        if (!model) return null;
        return DimensionPrecomputeAccountStatus.newInstance(<DimensionPrecomputeAccountStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionPrecomputeAccountStatus) {
        if (!obj) return;

        models.DimensionPrecomputeAccountStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionPrecomputeAccountStatus): boolean {
        Object.setPrototypeOf(obj, DimensionPrecomputeAccountStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.records_reprocessed === undefined) {
            this.records_reprocessed = 0;
        }
        if (typeof this.completed_at === "string") {
            this.completed_at = new Date(<string><any>this.completed_at);
        }
    }

    /**
     * Billing/processing service account ID
     */
    service_account_id: string;

    /**
     * Status: completed, failed, in_progress, no_data, pending
     */
    status: models.DimensionPrecomputeStatus;

    /**
     * head_version sys_id at time of last successful precompute
     */
    last_precomputed_version_id: string;

    /**
     * Records reprocessed in last run
     */
    records_reprocessed: number;

    /**
     * Status message or error detail
     */
    message: string;

    /**
     * When this account last completed precompute
     */
    completed_at: Date;

}
